import { ResponsivePie } from '@nivo/pie';
import { useEffect, useState } from 'react';
import { commonHelpers } from 'utilities/helpers';

type props = {
    data: any[];
    amount: string;
};

const PieChart = ({ data, amount }: props) => {
    const [chartColors, setChartColors] = useState<string[]>([]);

    useEffect(() => {
        setChartColors(
            data?.map((item) => {
                return item.color ?? '';
            }),
        );
    }, [data]);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <ResponsivePie
                data={data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.5}
                padAngle={0.7}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{
                    from: 'color',
                    modifiers: [['darker', 0.2]],
                }}
                arcLinkLabelsSkipAngle={18}
                arcLinkLabelsTextOffset={8}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsOffset={5}
                arcLinkLabelsStraightLength={26}
                arcLinkLabelsThickness={0}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsSkipAngle={11}
                arcLabelsTextColor={{
                    from: 'color',
                    modifiers: [['darker', 2]],
                }}
                colors={chartColors}
                tooltip={() => <></>}
                enableArcLabels={false}
                arcLinkLabel={(e) => e.id + ' (' + commonHelpers.formatNumberMoney(e.value) + '円)'}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'column',
                        justify: false,
                        translateX: 20,
                        translateY: 80,
                        itemsSpacing: 5,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: 'circle',
                    },
                ]}
            />
            <div className="pie-chart__wrapper">
                <div className="pie-chart__desc">融資限度額</div>
                <div className="pie-chart__amount">{amount}</div>
            </div>
        </div>
    );
};

export default PieChart;
